// extracted by mini-css-extract-plugin
export default {"Slogan":"faq_Slogan__EbE2a","LandingContent":"faq_LandingContent__NF1gk","Content":"faq_Content__9sMo6"};